export enum ThemeEnum {
  SPARQ = 'SPARQ',
  SOFDCAR = 'SOFDCAR'
}
